import React from 'react';
import { Heart, User } from 'tabler-icons-react';
import {
  Card,
  Image,
  Text,
  Group,
  Badge,
  Button,
  ActionIcon,
  createStyles,
  useMantineTheme,
  PasswordInput,
  TextInput,
  Title,
  NumberInput
} from '@mantine/core';
import { PasswordStrength } from './PasswordStrength';
import logo from '../assets/logo192.png'





const useStyles = createStyles((theme) => ({
    card: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
        margin: '0 auto',
        width: "80%"
    },
    cardInput: {
        width: "80%"
    },
    titleText: {
        textAlign: "center"
    },
    forgotPw: {
        color: "blue",
        margin: "0 auto",
        textAlign: "center"
    },
    forgotPwContain: {
        textAlign: "center",
        width: "75%",
        margin: "0 auto"
    },
    inputFields: {
        width: '80%',
        margin: '0 auto'
    }
}));


export function AuthEnterCode() {
    const { classes } = useStyles();
    const theme = useMantineTheme();



    return (
        <Card shadow="sm" padding="lg" radius="md" withBorder className={classes.card}>
            <Card.Section>
                <Image src={logo} alt="Ready Auction" mx="auto" width={100} height={100}  withPlaceHolder/>
                <Title className={classes.titleText} inline={true}>Two-Step Code </Title>
            </Card.Section>
            <br/>
            <Card.Section>
                <NumberInput placeholder="Code" label="Enter 6 Digit Code" withAsterisk className={classes.inputFields}/>
                <br/>
            </Card.Section>
            <br/>
            <br/>
            <Button leftIcon={<User />} fullWidth={true}>
                Confirm Code
            </Button>
            <br/>
            <br/>
            <br/>
        </Card>
    );
}
